import LogoAl from '../../assets/logo_gov_al.png';
import './styles.css';


export default function HeaderSectiDash(){
       return (
        <div className='headerSectiDash'>
            <div className='imgLogoAl'>
                <img src={LogoAl} />
            </div>

            <h1 className='titleHeaderSecti'>SECTI</h1>
            
            <div></div>

        </div>
    )
}